import { useEffect } from 'react';
import ReactDOM from 'react-dom';

const GuideMask = ({ visible, children, refValue }) => {
  useEffect(() => {
    if (visible && refValue) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    // 清理函数：组件卸载时恢复滚动
    return () => {
      document.body.style.overflow = '';
    };
  }, [visible, refValue]);

  if (!visible || !refValue) return null;

  return ReactDOM.createPortal(
    <>
      <div className={'fixed bg-black opacity-40 inset-0 z-[10]'} />
      {ReactDOM.createPortal(children, refValue)}
    </>,
    document.body
  );
};

export default GuideMask;
